<template>
  <div class="team-list">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/salesSupervisor/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>团队管理</el-breadcrumb-item>
      <el-breadcrumb-item>销售列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索区域 -->
    <div class="search-section">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="销售名称">
          <el-input
            v-model="formInline.saleName"
            placeholder="请输入姓名或用户名"
            clearable
            class="search-input"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="toolbar">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">新增销售</el-button>
      <el-button
        size="small"
        type="danger"
        icon="el-icon-delete"
        :disabled="!selectedRows.length"
        @click="batchRemove"
      >
        批量移除
      </el-button>
    </div>

    <!-- 列表区域 -->
    <el-card shadow="hover" class="table-card">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无数据"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column label="用户名" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="copyable-cell" title="双击复制" @dblclick="copyToClipboard(scope.row.username)">{{ scope.row.username || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="姓名" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="copyable-cell" title="双击复制" @dblclick="copyToClipboard(scope.row.name)">{{ scope.row.name || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="身份证号" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="copyable-cell" title="双击复制" @dblclick="copyToClipboard(scope.row.idNo)">{{ scope.row.idNo || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="copyable-cell" title="双击复制" @dblclick="copyToClipboard(scope.row.phoneNumber)">{{ scope.row.phoneNumber || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="邮箱" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="copyable-cell" title="双击复制" @dblclick="copyToClipboard(scope.row.mail)">{{ scope.row.mail || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="location" label="所在地" show-overflow-tooltip></el-table-column>
      <el-table-column label="角色" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag :type="getRoleTagType(scope.row.roleId)" size="small" effect="plain">
            {{ getRoleName(scope.row.roleId) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag :type="getStatusTagType(scope.row.status, scope.row.statusStr)" size="small" effect="plain">
            {{ scope.row.statusStr || '--' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdAtStr" label="创建时间" width="160" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="280" fixed="right">
        <template slot-scope="scope">
          <el-button class="op-btn-sm" size="small" type="primary" plain @click="handleEdit(scope.$index, scope.row)">修改</el-button>
          <el-button class="op-btn-sm" size="small" type="success" plain @click="handleRedirect(scope.row)">跳转</el-button>
          <el-button class="op-btn-sm" size="small" type="danger" @click="removeFromTeam(scope.$index, scope.row)">移除</el-button>
        </template>
      </el-table-column>
      </el-table>
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="pagination-wrap" />
    </el-card>

    <!-- 新增/编辑 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="680px" class="edit-form-dialog" @close="closeDialog">
      <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="用户名" prop="username">
              <el-input size="small" v-model="editForm.username" placeholder="用户名" :disabled="!!editForm.userId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="editForm.userId ? '新密码' : '密码'" prop="password">
              <el-input
                size="small"
                type="password"
                v-model="editForm.password"
                :placeholder="editForm.userId ? '不修改请留空' : '请输入不少于8位且不包含空格'"
                :disabled="!!editForm.userId"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input size="small" v-model="editForm.name" placeholder="名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idNo">
              <el-input size="small" v-model="editForm.idNo" placeholder="身份证号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="手机号" prop="phoneNumber">
              <el-input size="small" v-model="editForm.phoneNumber" placeholder="手机号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="mail">
              <el-input size="small" v-model="editForm.mail" placeholder="邮箱"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="所在地" prop="location">
              <el-select size="small" v-model="editForm.location" placeholder="请选择" style="width: 100%">
                <el-option label="石家庄" value="石家庄"></el-option>
                <el-option label="北京" value="北京"></el-option>
                <el-option label="其它" value="其它"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-select size="small" v-model="editForm.status" placeholder="请选择" style="width: 100%">
                <el-option label="在职" :value="1"></el-option>
                <el-option label="离职" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="submitLoading" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTeamSalesList, addTeamSales, updateTeamSales, removeTeamSales, getRedirectUrl } from '../../api/userMG';
import Pagination from '../../components/Pagination';

export default {
  name: 'SalesSupervisorTeamList',
  components: { Pagination },
  data() {
    return {
      loading: false,
      submitLoading: false,
      editFormVisible: false,
      title: '新增销售',
      formInline: {
        saleName: '',
        page: 1,
        pageSize: 10
      },
      listData: [],
      selectedRows: [],
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      editForm: {
        userId: '',
        id: '',
        username: '',
        name: '',
        phoneNumber: '',
        mail: '',
        location: '',
        idNo: '',
        status: 1,
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        location: [{ required: true, message: '请选择所在地', trigger: 'change' }],
        idNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { pattern: /^(\d{15}|\d{18})$/, message: '身份证号为15位或18位数字', trigger: 'blur' }
        ],
        phoneNumber: [
          { required: false, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 8, message: '密码不少于8位', trigger: 'blur' },
          { pattern: /^\S+$/, message: '密码不能包含空格', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取该团队下所有销售（分页）
    getList() {
      this.loading = true;
      const params = {
        page: this.pageparm.page,
        pageSize: this.pageparm.pageSize,
        saleName: this.formInline.saleName
      };
      getTeamSalesList(params)
        .then(res => {
          this.loading = false;
          if (res.msg === 'success' || res.code === 0) {
            const data = res.data || {};
            this.listData = Array.isArray(data.items) ? data.items : [];
            this.pageparm.total = data.totalCount != null ? data.totalCount : this.listData.length;
          } else {
            this.listData = [];
            this.pageparm.total = 0;
          }
        })
        .catch(() => {
          this.loading = false;
          this.listData = [];
          this.pageparm.total = 0;
        });
    },
    search() {
      this.pageparm.page = 1;
      this.getList();
    },
    reset() {
      this.formInline.saleName = '';
      this.pageparm.page = 1;
      this.getList();
    },
    callFather(parm) {
      this.pageparm.page = parm.page;
      this.pageparm.pageSize = parm.pageSize;
      this.getList();
    },
    copyToClipboard(text) {
      const str = text != null && text !== '' ? String(text) : '';
      if (!str) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(str).then(() => {
          this.$message.success('已复制');
        }).catch(() => {
          this.fallbackCopy(str);
        });
      } else {
        this.fallbackCopy(str);
      }
    },
    fallbackCopy(text) {
      const el = document.createElement('textarea');
      el.value = text;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand('copy');
        this.$message.success('已复制');
      } catch (e) {
        this.$message.warning('复制失败');
      }
      document.body.removeChild(el);
    },
    getRoleName(roleId) {
      const map = { 1: '管理员', 2: '风控', 3: '代理', 4: '销售', 5: '运营', 6: '主管' };
      return map[roleId] != null ? map[roleId] : (roleId != null ? `角色${roleId}` : '--');
    },
    getRoleTagType(roleId) {
      const map = { 1: 'warning', 2: 'info', 3: 'success', 4: 'primary', 5: 'info', 6: 'warning' };
      return map[roleId] != null ? map[roleId] : 'info';
    },
    getStatusTagType(status, statusStr) {
      if (status === 1 || (statusStr && statusStr.indexOf('在职') !== -1)) return 'success';
      if (status === 0 || (statusStr && (statusStr.indexOf('离职') !== -1 || statusStr.indexOf('禁用') !== -1))) return 'danger';
      return 'info';
    },
    handleEdit(index, row) {
      this.title = row ? '修改销售' : '新增销售';
      this.editForm = {
        userId: row ? row.userId : '',
        id: row ? row.id : '',
        username: row ? row.username : '',
        name: row ? row.name : '',
        phoneNumber: row ? row.phoneNumber || '' : '',
        mail: row ? row.mail || '' : '',
        location: row ? row.location || '' : '',
        idNo: row ? row.idNo || '' : '',
        status: row ? (row.status !== undefined ? row.status : 1) : 1,
        password: ''
      };
      if (row) {
        this.rules.password = [
          { min: 8, message: '密码不少于8位', trigger: 'blur' },
          { pattern: /^\S*$/, message: '密码不能包含空格', trigger: 'blur' }
        ];
      } else {
        this.rules.password = [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 8, message: '密码不少于8位', trigger: 'blur' },
          { pattern: /^\S+$/, message: '密码不能包含空格', trigger: 'blur' }
        ];
      }
      this.editFormVisible = true;
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate());
    },
    handleRedirect(row) {
      const redirectUserId = row && (row.userId != null ? row.userId : row.id);
      if (redirectUserId == null || redirectUserId === '') {
        this.$message.warning('该用户无跳转参数');
        return;
      }
      const username = (row && (row.username || row.name)) || '该用户';
      this.$confirm(`将跳转到 ${username} 账号，是否继续？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return getRedirectUrl({ redirectUserId: String(redirectUserId) });
        })
        .then((res) => {
          if (res && res.msg === 'success' && res.data != null) {
            const url = typeof res.data === 'string' ? res.data : (res.data.url || res.data.data || '');
            if (url) {
              const newWindow = window.open('', '_blank');
              if (newWindow) {
                newWindow.location.href = url;
              } else {
                this.$message({
                  type: 'warning',
                  message: '跳转弹窗被拦截，请允许弹窗后重试'
                });
              }
            } else {
              this.$message.error('未获取到跳转地址');
            }
          } else {
            this.$message({
              type: 'error',
              message: (res && (res.msg || res.message)) || '获取跳转地址失败'
            });
          }
        })
        .catch((err) => {
          if (err === 'cancel') return;
          const data = err && err.response && err.response.data;
          const msg = (data && (data.msg || data.message)) || (err && err.message) || '获取跳转地址失败';
          this.$message({ type: 'error', message: msg });
        });
    },
    closeDialog() {
      this.editFormVisible = false;
      this.editForm = {
        userId: '',
        id: '',
        username: '',
        name: '',
        phoneNumber: '',
        mail: '',
        location: '',
        idNo: '',
        status: 1,
        password: ''
      };
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return;
        this.submitLoading = true;
        const isAdd = !this.editForm.userId;
        const payload = {
          username: this.editForm.username,
          name: this.editForm.name,
          phoneNumber: this.editForm.phoneNumber || undefined,
          mail: this.editForm.mail || undefined,
          location: this.editForm.location || undefined,
          idNo: this.editForm.idNo || undefined,
          status: this.editForm.status
        };
        if (isAdd) {
          payload.password = this.editForm.password;
        } else {
          payload.id = this.editForm.id;
          payload.userId = this.editForm.userId;
          if (this.editForm.password) payload.password = this.editForm.password;
        }
        const api = isAdd ? addTeamSales(payload) : updateTeamSales(payload);
        api
          .then(res => {
            this.submitLoading = false;
            if (res.msg === 'success' || res.code === 0) {
              this.$message.success(isAdd ? '新增成功' : '修改成功');
              this.closeDialog();
              this.getList();
            } else {
              this.$message.error(res.msg || res.message || '操作失败');
            }
          })
          .catch(err => {
            this.submitLoading = false;
            this.$message.error((err && err.msg) || '操作失败');
          });
      });
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows || [];
    },
    // 调用移除接口：removeTeamSales(teamId, params)，params 作为请求体 data，需包含 salesIds: List<Integer>
    doRemoveTeamSales(teamId, salesIds) {
      const params = { salesIds: salesIds.map((id) => Number(id)).filter((n) => !isNaN(n)) };
      if (!params.salesIds.length) {
        this.$message.warning('销售 id 无效');
        return Promise.reject();
      }
      return removeTeamSales(teamId, params)
        .then((res) => {
          if (res.msg === 'success' || res.code === 0) {
            this.getList();
            return res;
          }
          this.$message.error(res.msg || res.message || '移除失败');
          return Promise.reject(res);
        })
        .catch((err) => {
          this.$message.error(err && (err.msg || err.message) || '移除失败');
          return Promise.reject(err);
        });
    },
    removeFromTeam(index, row) {
      const teamId = row.teamId;
      if (teamId == null || teamId === '') {
        this.$message.warning('无法获取团队信息');
        return;
      }
      const nameTip = row.name || row.username || '该销售';
      this.$confirm(`确定将 ${nameTip} 从团队中移除？`, '提示', { type: 'warning' })
        .then(() => {
          this.loading = true;
          this.doRemoveTeamSales(teamId, [row.id]).then(() => {
            this.loading = false;
            this.$message.success('已移除');
          }).catch(() => { this.loading = false; });
        })
        .catch(() => {});
    },
    batchRemove() {
      if (!this.selectedRows.length) {
        this.$message.warning('请先勾选要移除的销售');
        return;
      }
      const teamId = this.selectedRows[0].teamId;
      if (teamId == null || teamId === '') {
        this.$message.warning('无法获取团队信息');
        return;
      }
      const salesIds = this.selectedRows.map((r) => r.id).filter((id) => id != null);
      if (!salesIds.length) {
        this.$message.warning('勾选数据异常');
        return;
      }
      this.$confirm(`确定将选中的 ${salesIds.length} 名销售从团队中移除？`, '提示', { type: 'warning' })
        .then(() => {
          this.loading = true;
          this.doRemoveTeamSales(teamId, salesIds).then(() => {
            this.loading = false;
            this.selectedRows = [];
            this.$message.success('已批量移除');
          }).catch(() => { this.loading = false; });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.team-list {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}

/* 搜索区域 */
.search-section {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 0;
  margin-right: 20px;
}
.search-form .search-input {
  width: 200px;
}

/* 列表卡片 */
.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.table-card >>> .el-card__header {
  padding: 14px 20px;
  border-bottom: 1px solid #ebeef5;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-title {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
}
.toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 16px 0;
}
.toolbar .el-button {
  margin-left: 0;
}
.selected-num {
  margin-left: 2px;
  font-size: 12px;
  opacity: 0.9;
}
.pagination-wrap {
  margin-top: 16px;
}

/* 表格单元格 */
.copyable-cell {
  cursor: copy;
  user-select: none;
}
.copyable-cell:hover {
  color: #409eff;
}
.op-btn-sm {
  padding: 5px 10px;
  font-size: 12px;
}

/* 新增/编辑弹窗 */
.edit-form-dialog >>> .el-dialog {
  border-radius: 8px;
}
.edit-form-dialog >>> .el-dialog__header {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
}
.edit-form-dialog >>> .el-dialog__title {
  font-size: 16px;
  color: #303133;
}
.edit-form-dialog >>> .el-dialog__body {
  padding: 16px 20px 10px;
}
.edit-form-dialog >>> .el-dialog__body .el-form-item {
  margin-bottom: 12px;
}
.edit-form-dialog >>> .el-dialog__footer {
  padding: 12px 20px 20px;
  text-align: right;
}
.edit-form-dialog >>> .dialog-footer .el-button {
  min-width: 72px;
}
</style>



// WEBPACK FOOTER //
// src/views/salesSupervisor/teamList.vue